export default {
  'Please select an output format': 'アウトプットするフォーマットを選択してください',
}